import { APP_BOTTOM_BAR_HEIGHT } from "@/constants/layout";

/** Wenn weder Safe-Area noch env() einen Wert liefern. */
export const APP_BOTTOM_BAR_MIN_INSET = 8;

/**
 * Unterer Abstand der Bottom-Nav: der größere Wert aus der nativen Safe Area,
 * env(safe-area-inset-bottom) und dem Mindestabstand.
 * Die Inhaltshöhe bleibt `APP_BOTTOM_BAR_HEIGHT` aus der Layout-Konstante.
 */
export function bottomBarInset(safeAreaBottom: number, envInset = 0): number {
  const native = Number.isFinite(safeAreaBottom) ? safeAreaBottom : 0;
  const fromEnv = Number.isFinite(envInset) ? envInset : 0;
  return Math.max(native, fromEnv, APP_BOTTOM_BAR_MIN_INSET);
}

export function bottomBarHeight(safeAreaBottom: number, envInset = 0): number {
  return APP_BOTTOM_BAR_HEIGHT + bottomBarInset(safeAreaBottom, envInset);
}
